import Mutations from '../../odata/mutations';

export default new Mutations('budgetDocuments');
